import { AxiosResponse } from "axios";

// Api's
import { api } from "./base/api";
import { IQuoteHistoricalApi } from "./base";

// Models
import { Result } from "../models/common/resultResponse";
import { QuoteHistoricalMainResponse, QuoteHistoricalResponse } from "../models/response/quoteHistoricalResponse";
import { QuoteHistoryRequest } from "../models/request";
import { PaginationRequest } from "../models/common/paginationRequest";
import { PaginationResponse } from "../models/common/paginationResponse";

// Utils

const baseRoute: string = "QuoteHistorical";

export class QuoteHistoricalApi extends IQuoteHistoricalApi {
	getQuoteHistory(
		request: PaginationRequest,
		guidQuote: string,
	): Promise<AxiosResponse<PaginationResponse<QuoteHistoricalMainResponse>, any>> {
		return api.get(`${baseRoute}/quotehistory`, {
			params: { ...request, guidQuote },
		});
	}
	getQuoteHistoryDetail(request: QuoteHistoryRequest): Promise<AxiosResponse<Result<QuoteHistoricalResponse>>> {
		return api.get(`${baseRoute}/quotehistorydetail`, { params: request });
	}
}
